const equipment = {
  state: {
    enhanceJs: {

    }
  },
  mutations: {

  }
}
export default equipment
